import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

export class DestinatarioInternoVO {
  idCmu: string;
  nomeCmu: string;
  tipoDestinatario: TipoDestinatarioEnum = TipoDestinatarioEnum.DIRETTO;
  responsabile: string;
}
